import { dateFormatter, dateTimeFormatter, numberFormatter } from "../../../gridFormatters";

export const collectionDateDef = [
  {
    "field": "collection_date",
    "headerName": "Collection Date",
    "cellRenderer": dateFormatter
  }
];

export const allUsedTrendDefs = [
  {
    "field": "total_free",
    "type": "numericColumn",
    "headerName": "Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "total_used",
    "type": "numericColumn",
    "headerName": "Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "orphan_gb",
    "type": "numericColumn",
    "headerName": "Orphaned",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "usable_gb",
    "type": "numericColumn",
    "headerName": "Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allPhysUsedTrendDefs = [
  {
    "field": "physical_free",
    "type": "numericColumn",
    "headerName": "Physical Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_used",
    "type": "numericColumn",
    "headerName": "Physical Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "orphan_gb",
    "type": "numericColumn",
    "headerName": "Orphaned",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const NodeUsedTrendDefs = [
  {
    "field": "total_free",
    "type": "numericColumn",
    "headerName": "Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "used",
    "type": "numericColumn",
    "headerName": "Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "usable",
    "type": "numericColumn",
    "headerName": "Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const NodePhysUsedTrendDefs = [
  {
    "field": "physical_free",
    "type": "numericColumn",
    "headerName": "Phys. Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_used",
    "type": "numericColumn",
    "headerName": "Phys. Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_usable",
    "type": "numericColumn",
    "headerName": "Phys. Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const VolumeUsedTrendDefs = [
  {
    "field": "free",
    "type": "numericColumn",
    "headerName": "Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "used",
    "type": "numericColumn",
    "headerName": "Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
  // {
  // 	"field": "usable_gb",
  // 	"type": "numericColumn",
  // 	"headerName": "Capacity",
  // 	"cellRenderer": numberFormatter
  // }
];

export const VolumePhysUsedTrendDefs = [
  {
    "field": "physical_free",
    "type": "numericColumn",
    "headerName": "Phys. Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_used",
    "type": "numericColumn",
    "headerName": "Phys. Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const ShareUsedTrendDefs = [
  {
    "field": "used",
    "type": "numericColumn",
    "headerName": "Pool Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "allocated",
    "type": "numericColumn",
    "headerName": "Allocated",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const PoolUsedTrendDefs = [
  {
    "field": "total_free",
    "type": "numericColumn",
    "headerName": "Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "used",
    "type": "numericColumn",
    "headerName": "Pool Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "capacity",
    "type": "numericColumn",
    "headerName": "Pool Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const PoolPhysUsedTrendDefs = [
  {
    "field": "physical_free",
    "type": "numericColumn",
    "headerName": "Phys. Free",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_used",
    "type": "numericColumn",
    "headerName": "Phys. Used",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "physical_usable",
    "type": "numericColumn",
    "headerName": "Phys. Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allAllocatedTrendDefs = [
  {
    "field": "total_allocated",
    "type": "numericColumn",
    "headerName": "Allocated",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const otherAllocatedTrendDefs = [
  {
    "field": "allocated",
    "type": "numericColumn",
    "headerName": "Allocated",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allCapacityTrendDefs = [
  {
    "field": "usable_gb",
    "type": "numericColumn",
    "headerName": "Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allPhysCapacityTrendDefs = [
  {
    "field": "physical_usable",
    "type": "numericColumn",
    "headerName": "Physical Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const nodeCapacityTrendDefs = [
  {
    "field": "usable",
    "type": "numericColumn",
    "headerName": "Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const nodePhysCapacityTrendDefs = [
  {
    "field": "physical_usable",
    "type": "numericColumn",
    "headerName": "Physical Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const poolCapacityTrendDefs = [
  {
    "field": "capacity",
    "type": "numericColumn",
    "headerName": "Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const poolPhysCapacityTrendDefs = [
  {
    "field": "physical_capacity",
    "type": "numericColumn",
    "headerName": "Physical Capacity",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allCapacityDdrTrendDefs = [
  {
    "field": "device_name",
    "headerName": "Array Name"
  },
  {
    "field": "data_reduction_ratio",
    "type": "numericColumn",
    "headerName": "Data Reduction Ratio",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allCapacityByVolumeTrendDefs = [
  {
    "field": "volume_name",
    "headerName": "Volume Name",
    "enableRowGroup": true
  },
  {
    "field": "earliest_volume_used",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Earliest Volume Used"
  },
  {
    "field": "latest_volume_used",
    "headerName": "Latest Volume Used",
    "filter": "agNumberColumnFilter",
    "enableRowGroup": true,
    "type": "numericColumn"
  },
  {
    "field": "used_growth",
    "headerName": "Used Growth",
    "filter": "agNumberColumnFilter",
    "type": "numericColumn"
  },
  {
    "field": "earliest_collection_date",
    "headerName": "Earliest Collection Date",
    "cellRenderer": dateFormatter
  },
  {
    "field": "latest_collection_date",
    "headerName": "Latest Collection Date",
    "cellRenderer": dateFormatter
  }
];

export const allCapacityByShareTrendDefs = [
  {
    "field": "share_name",
    "headerName": "Share Name",
    "enableRowGroup": true
  }
];


export const allCapacityAllPoolsTrendDefs = [
  {
    "field": "pool_name",
    "headerName": "Pool Name"
  }
];

export const allIopsTrendDefs = [
  {
    "field": "iops",
    "headerName": "IOPS",
    "enableRowGroup": true,
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const otherIopsTrendDefs = [
  {
    "field": "iops",
    "headerName": "IOPS",
    "enableRowGroup": true,
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const volumeIopsTrendDefs = [
  {
    "field": "volume_iops",
    "headerName": "IOPS",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "enableRowGroup": true,
    "cellRenderer": numberFormatter
  }
];

export const nodeLatencyTrendDefs = [
  {
    "field": "avg_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Average Latency",
    "cellRenderer": numberFormatter
  },
  {
    "field": "latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Read Latency",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Write Latency",
    "cellRenderer": numberFormatter
  }
];

export const poolLatencyTrendDefs = [
  // {
  // 	"field": "avg_write_latency",
  // 	"type": "numericColumn",
  // 	"headerName": "Average Latency",
  // 	"cellRenderer": numberFormatter
  // },
  {
    "field": "latency",
    "type": "numericColumn",
    "headerName": "Read Latency",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_latency",
    "type": "numericColumn",
    "headerName": "Write Latency",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const volumeLatencyTrendDefs = [
  {
    "field": "avg_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Average Latency",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_latency",
    "type": "numericColumn",
    "headerName": "Read Latency",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
  // {
  // 	"field": "write_latency",
  // 	"type": "numericColumn",
  // 	"headerName": "Write Latency",
  // 	"cellRenderer": numberFormatter
  // }
];

export const otherLatencyTrendDefs = [
  {
    "field": "avg_latency",
    "type": "numericColumn",
    "headerName": "Average Latency",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_latency",
    "type": "numericColumn",
    "headerName": "Read Latency",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allMbsecTrendDefs = [
  {
    "field": "mbsec",
    "headerName": "MB/Sec",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "cellRenderer": numberFormatter
  }
];

export const allCpuTrendDefs = [
  {
    "field": "month_year",
    "headerName": "Month / Year"
  }
];

export const allNodeTrendDefs = [
  {
    "field": "device_name",
    "headerName": "Device Name"
  },
  {
    "field": "utilization",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Node/Cpu Util",
    "cellRenderer": numberFormatter
  }
];

export const realTimeTrendDefs = [
  {
    "field": "collection_date",
    "headerName": "Collection Date",
    "cellRenderer": dateTimeFormatter
  },
  {
    "field": "total_iops",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "IOPS (total)",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_iops",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Read IOPS",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_iops",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Write IOPS",
    "cellRenderer": numberFormatter
  },
  {
    "field": "total_mbsec",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "MB/Sec (total)",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_mbsec",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Read MB/Sec",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_mbsec",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Write MB/Sec",
    "cellRenderer": numberFormatter
  },
  {
    "field": "total_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Latency (avg)",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Read Latency",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_latency",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Write Latency",
    "cellRenderer": numberFormatter
  },
  {
    "field": "total_blksize",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Block Size (total)",
    "cellRenderer": numberFormatter
  },
  {
    "field": "read_blksize",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Read Block Size",
    "cellRenderer": numberFormatter
  },
  {
    "field": "write_blksize",
    "type": "numericColumn",
    "filter": "agNumberColumnFilter",
    "headerName": "Write Block Size",
    "cellRenderer": numberFormatter
  }
];